import Cookie from 'services/Cookie';
import { getActiveCompanyId } from 'utils/activeCompany';

function authHeaders() {
  const headers = {};
  const token = Cookie.get('token');
  if (token?.hash) {
    headers.Authorization = `Bearer ${token.hash}`;
  }
  const companyId = getActiveCompanyId();
  if (companyId) {
    headers['x-company'] = companyId;
  }
  return headers;
}

async function parseJsonResponse(response) {
  const payload = await response.json();
  if (!response.ok) {
    throw payload;
  }
  return payload;
}

function normalizeOidcRedirect(location) {
  const target = new URL(location, window.location.href);
  if (target.hostname === window.location.hostname && target.pathname.startsWith('/oidc')) {
    return `${window.location.origin}${target.pathname}${target.search}`;
  }
  return target.href;
}

async function followOidcRedirect(url, method = 'GET') {
  const response = await fetch(url, {
    method,
    credentials: 'include',
    headers: authHeaders(),
    redirect: 'manual',
  });

  if (response.status >= 300 && response.status < 400) {
    const location = response.headers.get('Location');
    if (!location) {
      throw new Error('Missing redirect Location');
    }
    return normalizeOidcRedirect(location);
  }

  if (!response.ok) {
    throw await parseJsonResponse(response);
  }

  return null;
}

class OidcInteractionApi {
  getDetails(uid) {
    return fetch(`/oauth/authorize/${uid}/details`, {
      credentials: 'include',
      headers: authHeaders(),
    }).then(parseJsonResponse);
  }

  confirmUrl(uid) {
    return `/oauth/authorize/${uid}/confirm`;
  }

  abortUrl(uid) {
    return `/oauth/authorize/${uid}/abort`;
  }

  async complete(uid) {
    const resumeUrl = await followOidcRedirect(this.confirmUrl(uid), 'POST');
    if (!resumeUrl) {
      return;
    }
    window.location.assign(resumeUrl);
  }

  abort(uid) {
    return followOidcRedirect(this.abortUrl(uid), 'POST');
  }
}

export default new OidcInteractionApi();
